import styled from 'styled-components';

export const FormTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #393939;
`;
export const StyledForm = styled.form`
  background: ${({ isPrivate }) => (isPrivate ? '#fefcf7' : '#fff')};

  .notification {
    .label {
      font-weight: 500;
      font-size: 12px;
      line-height: 19px;
      padding-left: 2px;
      margin-bottom: 8px;
      width: 100%;
      padding-bottom: 8px;
      border-bottom: 0.5px solid #e8e8e8;
    }
  }
`;
